import { CREATE, GET_ONE, GET_LIST } from 'react-admin';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
import * as constants from '../../constants/index';
import { APP_INFO, AuthActionTypes, IAM_LISTS } from './types';

export const getAppInfo = (): AuthActionTypes => ({
    type: APP_INFO,
    meta: { fetch: GET_ONE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.PROPERTIES.APP_INFO}` },
});
export const LoginAction = (data: any) => ({
    type: LOGIN,
    payload: { data: { ...data } },
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AUTH.LOGIN}` },
});

export const logoutAction = (completeLogout: boolean) => ({
    type: LOGOUT,
    payload: { data: { completeLogout: completeLogout } },
    meta: { fetch: CREATE, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.AUTH.LOGOUT}` },
});

export const getIamLists = (): AuthActionTypes => ({
    type: IAM_LISTS,
    meta: { fetch: GET_LIST, resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.SECURITY.IAM_LISTS}` },
});
